/*
 * THIS FILE WAS GENERATED BY "@atproto/lex". DO NOT EDIT.
 */

export * from "./listTargets.defs.js";
export { main as default } from "./listTargets.defs.js";
